export const SUPPORT_URL = 'https://buymeacoffee.com/getradicaldude';

export const SUPPORT_HANDLE = '@getradicaldude';






